class TabsEvents {
  constructor() {
    document.querySelectorAll('.tab-content').forEach(content => {
      content.classList.add('hide');
    });
    document.querySelectorAll('.tabs:not(.tabs--links)').forEach(tab => {
      tab.querySelectorAll('.tabs__slide').forEach(slide => {
        let id_attr = slide.getAttribute('id');

        if (id_attr.length > 0) {

          if (slide.classList.contains('tabs--active')) {
            document.querySelector('#' + id_attr + '-content' ).classList.remove('hide');
          }

          slide.querySelector('a').addEventListener('click', (e) => {
            e.preventDefault();
            //let slide_id = slide.getAttribute('id');
            tab.querySelectorAll('.tabs__slide').forEach( current_slide => {
              if( current_slide.getAttribute('id') == id_attr ) {
                current_slide.classList.add('tabs--active');
              } else {
                current_slide.classList.remove('tabs--active');
              }
            });
            document.querySelectorAll('.tab-content').forEach(content => {
              content.classList.add('hide');
            });
            document.querySelector('#' + id_attr + '-content').classList.remove('hide');
            e.stopPropagation();
          });
        }
      })
    });
  }
}

export default TabsEvents;